export default __webpack_public_path__ + "static/media/map_pin_avvik_fra_kontrollør.243c0a20.svg";